<template>
  <portlet
      :icon="'fal fa-cog portlet-icon'"
      :title="$t('oeeAnalytics.oeeCharts.settings')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
  >
    <template slot="actionsBlock">
      <div v-if="showCloseButton" @click="$emit('closePortletClicked')" class="toggle-filter-btn-clos">
        <div class="toggle-button">
          <!--          <i class="fas fa-angle-right toggle-icon"></i>-->
          <i class="fas fa-times" style="cursor: pointer"></i>
        </div>
      </div>
    </template>
    <template slot="portletBody">

      <div class="row settings-row">
        <div v-show="diffInDays > 45" class="alert alert-info">
          <p>Loading might be slower due to longer date range
          </p>
        </div>
        <!--        <div class="col-12">-->
        <!--          <button @click="resetSelectedFocusDate()" style="height: 100%; width: 100%"-->
        <!--                  class="btn-wrap btn btn-outline-primary">-->
        <!--            {{ $t('oeeAnalytics.oeeCharts.resetSelectedFocusDate') }}-->
        <!--          </button>-->
        <!--        </div>-->
        <div class="col-12">

          <label for="oee-chart-grouped-by-select">{{ $t('oeeAnalytics.oeeCharts.dateRange') }}</label>
          <select name="" class=form-control v-model="dateRangeSelect" @change="setDateRange()"
                  id="oee-chart-grouped-by-select">
            <option :key="index+1" v-for="(dateOption,index) in dateRangeOptions" :value="dateOption.value">
              {{ dateOption.text }}
            </option>

            <option value="custom"> {{ $t('ui.timespan.custom') }}</option>

          </select>

        </div>
        <template v-if="dateRangeSelect === 'custom' ">

          <div class="col-12">
            <label for="fromDate">{{ $t("ui.from") }}</label>
            <datepicker
                monday-first

                :language="en"
                :format="dateDisplay"
                @selected="updateDateRange('fromDate', $event)"
                :disabledDates="getDisabledDatesFrom"
                :value="dateRange.fromDate"
                id="fromDate"
                class="right-aligned-calendar"
                input-class="form-control  "
            />
          </div>
          <div class="col-12">
            <label for="toDate">{{ $t("ui.to") }}</label>
            <datepicker
                monday-first
                use-utc
                :disabledDates="getDisabledDatesTo"
                @selected="updateDateRange('toDate', $event)"
                :language="en"
                :format="dateDisplay"
                :value="dateRange.toDate"
                id="toDate"
                class="right-aligned-calendar top"
                input-class="form-control "
            />
          </div>
        </template>


      </div>

      <hr>

      <div class="row settings-row">
        <div class="col-12">
          <label for="oee-chart-workflow-select">{{ $t('oeeAnalytics.oeeCharts.workflows') }}</label>
          <select @change="updateSelectedWorkflow" name="" class=form-control v-model="selectedWorkflow"
                  id="oee-chart-workflow-select">
            <option :value="null">{{ $t('ui.all') }}</option>
            <option v-bind:key="workflow.id" v-for="workflow in getWorkflows" :value="workflow.id">{{
                workflow.name
              }}
            </option>
          </select>
        </div>

<!--        <div class="col-12">-->
<!--          <label for="oee-chart-grouped-by-select"> OEE {{ $t('oeeAnalytics.oeeCharts.grouping') }}</label>-->
<!--          <select @change="updateUnit" name="" class=form-control v-model="unit" id="oee-chart-grouped-by-select">-->
<!--            <option value="day">-->
<!--              {{ $t('oeeAnalytics.oeeCharts.group.day') }}-->
<!--            </option>-->
<!--            <option value="week">-->
<!--              {{ $t('oeeAnalytics.oeeCharts.group.week') }}-->
<!--            </option>-->
<!--            <option-->
<!--                value="month">{{ $t('oeeAnalytics.oeeCharts.group.month') }}-->
<!--            </option>-->
<!--            <option value="year">-->
<!--              {{ $t('oeeAnalytics.oeeCharts.group.year') }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </div>-->
        <div class="col-12">
          <button @click="saveDateRange()" style="height: 100%; width: 100%" class="btn btn-outline-primary">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>

    </template>
  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import {en} from "vuejs-datepicker/dist/locale";

export default {
  name: "Filters",
  props: ['showCloseButton'],
  data() {
    return {
      selectedWorkflow: null,
      groupedBy: null,
      selectedDate: null,
      en,
      dateRangeSelect: {
//        fromDate: moment().utc(true).startOf('date').toDate(),
//         fromDate: moment().utc().startOf('date').toDate(),
//         toDate: moment().utc().endOf('date').toDate(),
      },
      dateRangeOptions: [{
        text: this.$t('ui.timespan.today'),
        value: {
          fromDate: moment().startOf('date').utc().toDate(),
          toDate: moment().endOf('date').utc().toDate()
        }
      },
        {
          text: this.$t('ui.timespan.yesterday'),
          value: {
            fromDate: moment().subtract(1, 'day').startOf('date').utc().toDate(),
            toDate: moment().subtract(1, 'day').endOf('date').utc().toDate(),
          }
        },
        {
          text: this.$t('ui.timespan.currentWeek'),
          value: {
            fromDate: moment().startOf('isoWeek').utc().toDate(),
            toDate: moment().endOf('day').utc().toDate(),
          }
        },

        {
          text: this.$t('ui.timespan.currentMonth'),
          value: {
            fromDate: moment().startOf('month').utc().toDate(),
            toDate: moment().endOf('day').utc().toDate(),
          }
        },
        {
          text: this.$t('ui.timespan.currentYear'),
          value: {
            fromDate: moment().startOf('year').utc().toDate(),
            toDate: moment().endOf('day').utc().toDate()
          }
        }
      ],
      dateRange: {
        fromDate: null,
        toDate: null
      },
      unit: 'day'
    }
  },
  computed: {
    ...mapGetters('workflows', [
      'getWorkflows']),
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getDateRange']),
    //@vuese
    // Gets disabled dates To
    getDisabledDatesTo() {
      return {
        to: this.dateRange.fromDate, // Disable all dates up to specific date
        from: moment().utc().toDate()
      };
    },
    //@vuese
    // Gets disabled dates From
    getDisabledDatesFrom() {
      return {
        from: this.dateRange.toDate, // Disable all dates up to specific date
        to: moment(this.dateRange.toDate).subtract(1, "year").utc().toDate()
      };
    },
    diffInDays() {
      return moment(this.dateRange.toDate).diff(this.dateRange.fromDate, 'days')
    }
  },
  methods: {
    setDateRange() {
      if (this.dateRangeSelect === 'custom') {
        return
      } else {
        this.dateRange = this.dateRangeSelect
      }
    },
    updateSelectedWorkflow() {
      this.$store.commit('oeeAnalytics/setWorkflowId', this.selectedWorkflow);
    },
    saveDateRange() {

      localStorage.setItem('oeeDefaultFromDate', this.dateRange.fromDate.toISOString());
      localStorage.setItem('oeeDefaultToDate', this.dateRange.toDate.toISOString());
      this.$store.commit('oeeAnalytics/setSelectedDate', null)
      this.$store.commit('oeeAnalytics/setDateRange', null);




      this.$store.commit('oeeAnalytics/setDateRange', _.cloneDeep(this.dateRange));
      this.$emit('updateData', moment().toDate())
    },
    updateDateRange(element, $event) {

      if (element === 'toDate' && moment($event).isSame(moment(), 'day')) {
        $event = moment().utc().toDate()
      }
      if (element === 'toDate' && !moment($event).isSame(moment(), 'day')) {
        $event = moment($event).endOf('day').utc().toDate()
      }
       this.dateRange[element] = $event
    },
    resetSelectedFocusDate() {
      this.$store.commit('oeeAnalytics/setSelectedDate', null);
    },
    dateDisplay(date) {
      console.log(date)
      return moment(date).format("DD-MM-YYYY");
    },
    updateUnit() {
      this.$store.commit('oeeAnalytics/setUnit', this.unit);
    },
    getLocalStorageDates() {
      const savedFromDate = localStorage.getItem('oeeDefaultFromDate');
      const savedToDate = localStorage.getItem('oeeDefaultToDate');

      if (savedToDate && savedFromDate) {
        this.dateRange = {
          fromDate: new Date(savedFromDate),
          toDate: new Date(savedToDate)
        };
        this.dateRangeSelect = this.dateRange
      } else {
        this.dateRange = {
          fromDate: moment().subtract(1, 'week').startOf('isoWeek').utc().toDate(),
          toDate: moment().utc().toDate()
        }
        this.dateRangeSelect = this.dateRange

      }
    }
  },
  watch: {},
  created() {
    this.updateUnit();
    this.resetSelectedFocusDate();
    // this.getLocalStorageDates();
    this.dateRangeSelect = this.dateRangeOptions[2].value
    this.dateRange = this.dateRangeSelect
    this.$store.commit('oeeAnalytics/setDateRange', this.dateRange)

  }
}
</script>

<style scoped>

.toggle-filter-btn-close {
  z-index: 999;
  cursor: pointer;
  font-size: 2.5rem;
  color: #00c9ff;
  position: fixed;
  right: 290px;
  top: calc(50% - 3rem);
  background-color: #ffffff;
  border: 1px solid #00c9ff;
  width: 4rem;
  height: 4rem;
  display: grid;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-items: center;
  -webkit-animation: swirl-in-fwd 0.1s ease-out 200ms both;
  animation: swirl-in-fwd 0.1s ease-out 200ms both;
  border-radius: 100px;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-3-15 15:29:0
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swirl-in-fwd
 * ----------------------------------------
 */
@-webkit-keyframes swirl-in-fwd {
  0% {
    -webkit-transform: rotate(-540deg) scale(0);
    transform: rotate(-540deg) scale(0);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotate(0) scale(1);
    transform: rotate(0) scale(1);
    opacity: 1;
  }
}

@keyframes swirl-in-fwd {
  0% {
    -webkit-transform: rotate(-540deg) scale(0);
    transform: rotate(-540deg) scale(0);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotate(0) scale(1);
    transform: rotate(0) scale(1);
    opacity: 1;
  }
}


</style>